import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart, ChartConfiguration, ChartOptions } from 'chart.js';
import { AssetData } from '../../../models/assetData.model';
import { BaseChartDirective } from 'ng2-charts';
import { AssetsCounts } from '../../../models/assetsCounts.model';
Chart.register(ChartDataLabels);

@Component({
  selector: 'lib-operations-analytics',
  standalone: false,
  templateUrl: './operations-analytics.component.html',
  styleUrl: './operations-analytics.component.scss'
})
export class OperationsAnalyticsComponent {
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  @Input() lineGraphData: any;
  @Input() counts?: AssetsCounts;
  @Input() customerCount!: number;
  @Output() getData = new EventEmitter<[number, string]>();
  @Input() customersData: AssetData = new AssetData();

  lineGraphColors: any [] = [];
  pageSize: number = 6;
  page: number = 0;
  graphType: string = 'Daily';
  graphDateType: string = 'LastUpdateTime';
  graphData: any = { labels: ['-'] };
  isFilterPopupVisible = false;

  title = 'ng2-charts-demo';

  public barChartLegend = true;
  public barChartPlugins = [ChartDataLabels];

  public barChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          padding: 30
        },
      },
      tooltip: {
        enabled: true,
      },
      datalabels: {
        anchor: 'start',
        align: 'end',
        color: '#fff',
        font: {
          weight: 'bold',
          size: 12,
        },
        formatter: (value: any) => value,
        clamp: false,
        clip: false,
      }
    },
    scales: {
      x: {
        stacked: false,
        grid: {
          display: false,
        },
        ticks: {
          maxRotation: 0,
          minRotation: 0,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          precision: 0,
        },
        grid: {
          display: false,
        },
      },
    },
    interaction: {
      mode: 'index',
      intersect: false
    },
  };
  
  ngOnInit(): void {
    // this.lineGraphColors.push("#ff6347");
    // this.lineGraphColors.push("#E072A4");
    // this.lineGraphColors.push("#8F00FF");
    
  }

  getOperationsAnalytics(eventData: [number, string]){
    this.getData.emit(eventData);
  }

  setGraphType(period: 'Daily' | 'Monthly' | 'Yearly') {
    this.graphType = period;
    this.getOperationsAnalytics([0, this.graphType]);
  }

  increasePage(val: number) {
    if (this.page + val >= 0) {
      this.page += val;
      this.getOperationsAnalytics([this.page, this.graphType]);
    }
  }

  toggleFilterPopup() {
    this.isFilterPopupVisible = !this.isFilterPopupVisible;
  }

  toggleDatasetVisibility(label: string) {
    const chartInstance = this.chart?.chart;

    if (!chartInstance) return;

    const datasetIndex = chartInstance.data.datasets.findIndex(
      (ds) => ds.label === label
    );

    if (datasetIndex > -1) {
      const meta = chartInstance.getDatasetMeta(datasetIndex);
      meta.hidden = !meta.hidden;
      chartInstance.update();
    }
  }
}
